module.exports = __webpack_public_path__ + "img/sendlane_logo@2x.e4209ba3.png";